module.exports = __webpack_public_path__ + "media/Video 4.f9ba1503.mp4";